export default "__VITE_ASSET__a4dad944__"